/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgForward10 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.707 1.293 15.414 5l-3.707 3.707-1.414-1.414 1.279-1.28a7 7 0 1 0 7.424 7.228L19 13h2a9 9 0 1 1-9.406-8.991l-1.301-1.302zm1.908 9.137c1.674 0 2.511 1.101 2.511 3.303 0 1.104-.213 1.944-.639 2.52s-1.05.864-1.872.864-1.446-.288-1.872-.864-.639-1.416-.639-2.52c0-2.202.837-3.303 2.511-3.303zm-3.537.117V17H8.665v-4.77l-1.494.504v-.828l1.908-1.359zm3.537 1.026c-.384 0-.664.172-.842.517s-.265.893-.265 1.643c0 .762.09 1.326.27 1.692s.459.549.837.549.657-.183.837-.549.27-.93.27-1.692c0-.75-.088-1.297-.266-1.643s-.457-.517-.841-.517z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgForward10 as Forward10 };
